import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=c7880f42&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=c7880f42&prod&lang=scss"
import style1 from "./Diagnostic.vue?vue&type=style&index=1&id=c7880f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7880f42",
  null
  
)

export default component.exports